import { mapState } from 'vuex';
import formMixin from '../../formMixin';
export default {
  name: 'NiotaClassicDevicesQrForm',
  mixins: [formMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      msg: 'Coming Soon'
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])
  }
};